export default __webpack_public_path__ + "static/media/operation-monitoring-orange.57047b93.svg";